import React from 'react';

const NotFound = () => {
    return (
        // not found page
        <div>
            <h1>404 sorry page not found.</h1>
            <p>Try again or go another path</p>
        </div>
    );
};

export default NotFound;